export default __webpack_public_path__ + "static/media/energymeter.e5ccfcde.webp";